/* eslint-disable no-undef */
(function (window) {
    "use strict";
    function defineCompetitionService() {
        let competitionService = {};
        competitionService.getCampaign = function (campaignId) {
            return axios.get("/api/CompetitionService/GetCampaign?campaignId=" + campaignId)
                .then(response => {
                return response;
            }).catch(error => {
                console.log("error", error);
                apiResponseHandlerHelepr.displayResponseMessageBasedOnApiResponseStatus(error.response.status, error.response.data.supportCode);
                return error.response;
            });
        }
        
        competitionService.getSitesByCampaign = function (campaignId) {
            return axios.get("/api/CompetitionService/GetSitesByCampaign?campaignId=" + campaignId)
                .then(response => {
                    return response;
                }).catch(error => {
                    console.log("error", error);
                    apiResponseHandlerHelepr.displayResponseMessageBasedOnApiResponseStatus(error.response.status, error.response.data.supportCode);
                    return error.response;
                });
        }
        competitionService.addOrUpdateSubmission = function (formData){
            return axios.post("/api/CompetitionService/AddOrUpdateSubmission", formData, { headers: {'Content-Type': 'multipart/form-data' }})
                .then(response => {
                return response;
            }).catch(error => {
                console.log("error", error);
                apiResponseHandlerHelepr.displayResponseMessageBasedOnApiResponseStatus(error.response.status, error.response.data.supportCode);
                return error.response;
            });
        };
        return competitionService;
    }
    //define globally if it doesn't already exist
    if (typeof (competitionService) === "undefined") {
        window.competitionService = defineCompetitionService();
    } else {
        console.log("competitionService already defined.");
    }
})(window);